import React from 'react';
import { Badge } from '@/components/ui/badge';

/**
 * Reusable metric tile for admin dashboards.
 * Extracted from AdminOverviewTab.jsx (iter123 refactor).
 */
export const MetricCard = ({ label, value, icon: Icon, color, subtext, trend }) => {
  const colors = {
    blue: 'bg-blue-50 border-blue-200',
    green: 'bg-green-50 border-green-200',
    amber: 'bg-amber-50 border-amber-200',
    purple: 'bg-purple-50 border-purple-200',
    emerald: 'bg-emerald-50 border-emerald-200',
  };

  const iconColors = {
    blue: 'text-blue-600',
    green: 'text-green-600',
    amber: 'text-amber-600',
    purple: 'text-purple-600',
    emerald: 'text-emerald-600',
  };

  return (
    <div className={`p-4 rounded-lg border ${colors[color]}`}>
      <div className="flex items-center justify-between mb-2">
        <Icon className={`w-5 h-5 ${iconColors[color]}`} />
        {trend && (
          <Badge
            variant="outline"
            className={trend.startsWith('+')
              ? 'text-emerald-600 border-emerald-300'
              : 'text-red-600 border-red-300'}
          >
            {trend}
          </Badge>
        )}
      </div>
      <p className="text-2xl font-bold text-slate-900">{value}</p>
      <p className="text-sm text-slate-600">{label}</p>
      {subtext && <p className="text-xs text-slate-500 mt-1">{subtext}</p>}
    </div>
  );
};

export const HealthIndicator = ({ name, status, details }) => {
  const configs = {
    healthy: { color: 'bg-green-500', text: 'text-green-600' },
    warning: { color: 'bg-amber-500', text: 'text-amber-600' },
    error: { color: 'bg-red-500', text: 'text-red-600' },
  };
  const c = configs[status] || configs.healthy;

  return (
    <div className="p-4 bg-slate-50 rounded-lg border border-slate-200">
      <div className="flex items-center gap-3">
        <div className={`w-3 h-3 rounded-full ${c.color} animate-pulse`} />
        <div className="flex-1">
          <p className="text-slate-900 font-medium">{name}</p>
          <p className="text-xs text-slate-500">{details}</p>
        </div>
        <Badge variant="outline" className={`${c.text} border-current`}>{status}</Badge>
      </div>
    </div>
  );
};
